<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="是否已删除 0未删除 1已删除" prop="deleted">
        <el-input v-model="form.deleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="创建人编码" prop="createUser">
        <el-input v-model="form.createUser" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker v-model="form.createTime" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="updateUser">
        <el-input v-model="form.updateUser" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="updateTime">
        <el-date-picker v-model="form.updateTime" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="订单主键（orders）" prop="orderId">
        <el-input v-model="form.orderId" placeholder="请输入订单主键（orders）" v-trim/>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="日志内容" prop="logInfo">
        <el-input v-model="form.logInfo" placeholder="请输入日志内容" v-trim/>
      </el-form-item>
      <el-form-item label="操作类型" prop="objType">
        <el-input v-model="form.objType" placeholder="请输入操作类型" v-trim/>
      </el-form-item>
      <el-form-item label="操作人" prop="memberId">
        <el-input v-model="form.memberId" placeholder="请输入操作人" v-trim/>
      </el-form-item>
      <el-form-item label="操作前数据" prop="beforeInfo">
        <el-input v-model="form.beforeInfo" placeholder="请输入操作前数据" v-trim/>
      </el-form-item>
      <el-form-item label="操作后数据" prop="afterInfo">
        <el-input v-model="form.afterInfo" placeholder="请输入操作后数据" v-trim/>
      </el-form-item>
      <el-form-item label="订单状态:0=待接单；1=已接单；2=进行中；3=已完成；99=已取消；" prop="orderStatus">
        <el-input v-model="form.orderStatus" placeholder="请输入订单状态:0=待接单；1=已接单；2=进行中；3=已完成；99=已取消；" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaOrderLogWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        deleted: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        orderId: '',
        title: '',
        logInfo: '',
        objType: '',
        memberId: '',
        beforeInfo: '',
        afterInfo: '',
        orderStatus: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/orderLog',
      'field.id': 'id'
    })
  }
}
</script>
